<template>
    <div class="account__header" style="background-image: url('/dist/images/job/6_Solar_Grey_Dark.png');">
        <div class="account__container pb-xl">
            <div class="account__header-title">
                <h1 class="h1 text--white"><span v-if="count.total">{{ count.total }}</span> jobs</h1>
                <button class="btn" @click="openModal">Add new job</button>
            </div>

            <ul class="account__header-infos">
                <li v-for="(item, key) in count" :key="key" class="account__header-info small semi text--white">
                    <span>{{ item }}</span> Jobs {{ key }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';

export default {
    props: {
        count: {
            type: Object,
            required: true,
        }
    },

    methods: {
        openModal() {
            EventBus.$emit('new-job-modal');

            if ('dataLayer' in window) {
                window.dataLayer.push({
                    event: 'newJob',
                    step: 'start'
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
    .account__header-title {
        @media screen and (max-width: 699px) {
            padding-bottom: 0;
        }
    }
</style>
